import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { UsersManagementService } from './usersManagement.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TenantsService } from './tenants.service';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  private authUrl = environment.authentication;

  private roleSubject = new BehaviorSubject<number | null>(null);
  private userDataSubject = new BehaviorSubject<any>(null);
  private userDataLoadedSubject = new BehaviorSubject<boolean>(false);

  console = console;

  constructor(
    private auth: AuthService,
    private usersManagementService: UsersManagementService,
    private tenantsService: TenantsService,
    private router: Router,
    private http: HttpClient
  ) {

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const session = sessionStorage.getItem('authToken');

    if (!session) {
      this.router.navigate(['/login']);
      return of(false);
    }

    let token: string;

    try {
      token = JSON.parse(session).token;
    } catch (e) {
      this.router.navigate(['/login']);
      return of(false);
    }

    return this.auth.userDataLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.auth.getUserData().pipe(take(1))),
      switchMap(user => {
        if (!user) {
          this.router.navigate(['/login']);
          return of(false);
        }
        if (!user.active) {
          this.router.navigate(['/login']);
          return of(false);
        }
        if (user.forcePasswordChange) {
          return this.tenantsService.loadCurrent().pipe(
            map(tenant => {
              // SSO tenants must not be forced through the local password reset flow.
              if (tenant?.useSso) {
                return true;
              }
              this.router.navigate(['/reset-password']);
              return false;
            }),
            catchError(() => {
              this.router.navigate(['/reset-password']);
              return of(false);
            })
          );
        }
        return of(true);
      }),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }


  logOut() {
    this.clearToken()

    this.router.navigate(['/login']);
  }

  isAuthenticated(): boolean {
    return this.getToken() ? true : false;
  }

  sendLoginData(email: string, password: string): Observable<any> {
    const body = {
      email: email,
      password: password
    };

    return this.http.post<any>(this.authUrl + "/login", body);
  }


  sendNewPassword(password: string): Observable<any> {
    const body = {
      "password": password,
    };

    return this.usersManagementService.resetUserPassword(password);
  }

  getToken() {
    const tokenData = JSON.parse(sessionStorage.getItem('authToken') as string);

    if (tokenData) {
      const currentTime = new Date().getTime();

      if (currentTime < tokenData.expiry) {
        return tokenData.token;
      } else {
        this.clearToken();
      }

    }
    return null;
  }

  returnUserName(): string[] | null {
    const tokenData = JSON.parse(sessionStorage.getItem('authToken') as string);

    if (tokenData) {
      const currentTime = new Date().getTime();

      if (currentTime < tokenData.expiry) {
        return [tokenData.token.name, tokenData.token.lastName];
      } else {
        this.clearToken();
      }

    }

    return null;
  }

  // Function to clear the token
  clearToken() {
    sessionStorage.removeItem('authToken'); // Remove token from session storage
  }

}







